import { Button, ButtonSize, EventNames } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { Modal, ModalButtons, ModalHeading, ModalText } from '../../ReactComponents/Modal/Modal';

export const showFatalErrorModal = () => {
    window.dispatchEvent(new CustomEvent(EventNames.FatalError));
};

export const FatalErrorModal = () => {
    const [isVisible, setIsVisible] = React.useState(false);

    React.useEffect(() => {
        window.addEventListener(EventNames.FatalError, showModal);

        return () => {
            window.removeEventListener(EventNames.FatalError, showModal);
        };
    }, []);

    const showModal = () => setIsVisible(true);

    const reloadWindow = () => window.location.reload();

    return (
        <Modal open={isVisible} onClose={reloadWindow}>
            <ModalHeading>{getTranslation(keys['checkout.error.generic'])}</ModalHeading>
            <ModalText>{getTranslation(keys['checkout.error.invalidActionPleaseRefresh'])}</ModalText>
            <ModalButtons>
                <Button size={ButtonSize.Medium} onClick={reloadWindow}>
                    {getTranslation(keys['checkout.error.refresh'])}
                </Button>
            </ModalButtons>
        </Modal>
    );
};
